import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Globals } from '../shared/globals';
import { Api } from '../shared/api';
import { CarId } from '../models/car-id.model';
import { JsonSerializer } from 'typescript-json-serializer';
import { response } from 'express';

/**
 * @export
 * @class AdminCarService
 */
@Injectable()
export class AdminCarService {
  private fetchCarIdsUrl: string;
  private deleteCarIdUrl: string;
  private fetchAllCarIdsUrl: string;
  private jsonSerializer = new JsonSerializer();

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private globals: Globals,
    private api: Api
  ) {
    this.fetchCarIdsUrl = this.globals.adminUrl('car');
    this.fetchAllCarIdsUrl = this.globals.adminUrl('car/all');
    this.deleteCarIdUrl = this.globals.adminUrl('car');
  }

  getAllCarIds(): Promise<CarId[]> {
    return this.authService
      .getToken()
      .then((result) => {
        const basicToken = 'Basic ' + result;

        return this.http
          .get(this.fetchAllCarIdsUrl, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: basicToken,
            },
          })
          .toPromise()
          .then((response: any[]) => {
            return response.map((item) =>
              this.jsonSerializer.deserializeObject<CarId>(item, CarId)
            );
          })
          .catch((err) => {
            return err;
          });
      })
      .catch((err) => {
        Promise.reject(err);
      });
  }
  getCarIds(): Promise<CarId[]> {
    return this.authService
      .getToken()
      .then((result) => {
        const basicToken = 'Basic ' + result;

        return this.http
          .get(this.fetchCarIdsUrl, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: basicToken,
            },
          })
          .toPromise()
          .then((response: any[]) => {
            return response.map((item) =>
              this.jsonSerializer.deserializeObject<CarId>(item, CarId)
            );
          })
          .catch((err) => {
            return err;
          });
      })
      .catch((err) => {
        Promise.reject(err);
      });
  }

  deleteCarId(identifier: string): Promise<void> {
    return this.authService
      .getToken()
      .then((result) => {
        const basicToken = 'Basic ' + result;

        return this.http
          .delete(`${this.deleteCarIdUrl}/${identifier}`, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: basicToken,
            },
          })
          .toPromise()
          .then((response) => {
            return;
          })
          .catch((err) => {
            return err;
          });
      })
      .catch((err) => {
        Promise.reject(err);
      });
  }
}
